import { CustomWindow } from '@utils/models/customwindow';

declare let window: CustomWindow;

const vizzitCookieName = '___vizzit';

function setVizzitCookieIfConsented(maxWaitMs = 2000) {
  const interval = 100;
  let waited = 0;

  const check = () => {
    if (window.$vizzit && window.Cookiebot?.consent?.statistics) {
      window.$vizzit.cookie.set();
    }
    else if (waited < maxWaitMs) {
      waited += interval;
      setTimeout(check, interval);
    }
    else {
      removeCookie(vizzitCookieName);
    }
  };

  check();
}

function removeCookie(name: string) {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
function handleConsentRevoked() {
  removeCookie(vizzitCookieName);
}

window.CookiebotCallback_OnLoad = () => {
  setVizzitCookieIfConsented();
};

window.CookiebotCallback_OnDecline = () => {
  handleConsentRevoked();
};
